{ Jadelet, Modal } from @danielx/dui
Observable from @danielx/observable

{ accuracy, grade } from ../lib/midi/game-score.civet
type { PracticeSession } from ../lib/midi/practice-session.civet

{round} := Math

type Results =
  stats: PracticeSession["stats"]
  score: number
  maxCombo: number
  // health emptied before the song's end
  failed?: boolean

// End-of-song Game Mode results: letter grade, accuracy, score, max combo,
// judgment counts, and Retry. Shown by the PracticeMode mixin when a game
// pass reaches the end of the song (showGameResults).
Template := Jadelet.exec """
  section.game-results
    h2 @heading
    .grade(class=@gradeClass) @grade
    table
      tbody
        tr
          td Score
          td @score
        tr
          td Accuracy
          td @accuracy
        tr
          td Max Combo
          td @maxCombo
        tr
          td Perfect
          td @perfect
        tr
          td Good
          td @good
        tr
          td Early / Late
          td @earlyLate
        tr
          td Wrong
          td @wrong
        tr
          td Miss
          td @miss
    section.buttons
      button(click=@retry) Retry
      button(click=@close) Done
"""

export GameResults := (player: Player) ->
  results := Observable undefined as Results?

  stat := (f: (r: Results) => string | number) -> ->
    r := results()
    if r then String f(r) else ""

  self :=
    heading: stat (r) -> if r.failed then "Failed!" else "Results"
    grade: stat (r) -> if r.failed then "💀" else grade accuracy r.stats
    gradeClass: -> "failed" if results()?.failed
    accuracy: stat (r) -> `${round accuracy(r.stats) * 100}%`
    score: stat (r) -> r.score.toLocaleString()
    maxCombo: stat (r) -> `${r.maxCombo}×`
    perfect: stat (r) -> r.stats.perfect
    good: stat (r) -> r.stats.good
    earlyLate: stat (r) -> r.stats.early + r.stats.late
    wrong: stat (r) -> r.stats.wrong
    miss: stat (r) -> r.stats.miss

    retry: ->
      Modal.hide()
      player.playFromStart()

    close: ->
      Modal.hide()

    element: null as! HTMLElement

  self.element = Template self

  player.showGameResults = (r: Results) ->
    results r
    Modal.show self.element,
      cancellable: true

  return self

export default GameResults
